import { useContext } from 'react';
import { Button, Grid, Typography, MenuItem, FormControlLabel, Checkbox } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import { TextField } from 'formik-mui';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { absenceSchema } from '../AbsenceDetailsContext';
import * as yup from 'yup';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { applicationContext } from 'helpers/services';
import { AbsenceTypology } from 'helpers/Enums';
import moment from 'moment';


let AbsenceForm = () => {
    let router = useLocation();
    let appService = useContext(applicationContext);

    let isNew = router.pathname.includes('/addnew');
    let title = isNew ? 'Nuova Assenza' : `Modifica Assenza`;

    type Absence = yup.InferType<typeof absenceSchema>;
    let form = useFormikContext<Absence>();


    return (
        <>
            <Grid container>
                <Grid item xs>
                    <Typography variant="h1">{title}</Typography>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} md={6}>
                    <Field
                        name="userName"
                        component={TextField}
                        select
                        label="Seleziona membro squadra"
                        size="small"
                    >
                        {appService.simecUsers
                            .filter(x => x.isDisabled === false || x.email === form.values.userName)
                            .filter(x => x.simecClaims.canGoToCustomer === true)
                            .map(u => <MenuItem key={u.email} value={u.email}>{u.firstName} {u.lastName}</MenuItem>)}
                    </Field>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Field
                        name="typology"
                        component={TextField}
                        select
                        label="Tipo di Assenza"
                        size="small"
                    >
                        <MenuItem value={AbsenceTypology.NotAvailable}>Non Disponibile</MenuItem>
                        <MenuItem value={AbsenceTypology.Other}>Altro</MenuItem>
                    </Field>
                </Grid>
                {form.values.typology === AbsenceTypology.Other &&
                    <Grid item xs={12}>
                        <Field
                            component={TextField}
                            name="otherTypology"
                            type="text"
                            label="Altra Tipologia"
                        />
                    </Grid>
                }
                <Grid item xs={12} md={6}>
                    <DesktopDatePicker
                        label="Da data"
                        value={form.values.startDate}
                        onChange={(value) => form.setFieldValue("startDate", moment(value))}
                        renderInput={props =>
                            <Field
                                {...props}
                                component={TextField}
                                name="startDate"
                                error={form.touched['startDate'] && !!form.errors['startDate']}
                                helperText={form.errors['startDate']}
                            />
                        }
                        inputFormat="DD/MM/YYYY"

                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <DesktopDatePicker
                        label="A data"
                        value={form.values.endDate}

                        onChange={(value) => form.setFieldValue("endDate", moment(value))}
                        renderInput={props =>
                            <Field
                                {...props}
                                component={TextField}
                                name="endDate"
                                error={form.touched['endDate'] && !!form.errors['endDate']}
                                helperText={form.errors['endDate']}
                            />
                        }

                    />
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="notes"
                        type="text"
                        label="Note"
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        label="Notifica HR via email"
                        name="notifyHr"
                        value={form.values.notifyHr}
                        checked={form.values.notifyHr}
                        onChange={(e: any) => form.setFieldValue('notifyHr', e.target.checked)}
                        control={<Field type="checkbox" name="notifyHr" component={Checkbox} color="secondary" />}
                    />
                </Grid>

            </Grid>
            <Grid container>
                <Grid item xs />
                <Grid item>
                    <Button
                        component={RouterLink}
                        variant="outlined"
                        color="secondary"
                        to={"/absences"}
                    >
                        Annulla
                    </Button>
                    <Button type="submit" variant="contained">
                        Salva
                    </Button>
                </Grid>
            </Grid>
            {/* <Grid container>
                <Grid item>absenceId = {form?.values?.absenceId}</Grid>
                <Grid item>userName = {form?.values?.userName}</Grid>
                <Grid item>typology = {form?.values?.typology}</Grid>
                <Grid item>otherTypology = {form?.values?.otherTypology}</Grid>
                <Grid item>notes = {form?.values?.notes}</Grid>
                <Grid item>startDate = {form?.values?.startDate}</Grid>
                <Grid item>endDate = {form?.values?.endDate}</Grid>
                <Grid item>notifyHr = {form?.values?.notifyHr}</Grid>
            </Grid> */}
        </>
    );
}

export default AbsenceForm;